import { ApiTarget, HttpClient } from '@packages/core/http';
import {
    Synonym,
    SynonymCreatePayload,
    FetchSynonymsOptions,
    GetSynonymsSearchTermsResponse,
} from '@packages/models/api/synonyms-search-term';

export class SynonymsService {
    constructor(private http: HttpClient) {}

    async fetchSynonyms(options: FetchSynonymsOptions): Promise<GetSynonymsSearchTermsResponse> {
        const { query, sort = 'updatedAt', direction = 'desc', page = 1, size = 10, abortSignal } = options;

        const queryParams = new URLSearchParams({
            query: query || '',
            sort: `${sort},${direction}`,
            page: page.toString(),
            size: size.toString(),
        });

        const response = await this.http.orchestrateRequest<GetSynonymsSearchTermsResponse>({
            method: 'GET',
            url: `/docs/admin/all-search-terms?${queryParams.toString()}`,
            signal: abortSignal,
            ignoreCache: true,
            apiTarget: ApiTarget.VinService,
        });

        if (!response.success) {
            throw new Error('Failed to fetch synonyms');
        }

        return response.data;
    }

    async createSynonym(payload: SynonymCreatePayload): Promise<Synonym> {
        const response = await this.http.orchestrateRequest<{ data: Synonym }>({
            method: 'POST',
            url: '/docs/admin/search-terms',
            body: payload,
            apiTarget: ApiTarget.VinService,
        });

        if (!response.success) {
            throw new Error('Failed to create synonym');
        }

        return response.data?.data;
    }
    async updateSynonym(id: string, payload: Partial<SynonymCreatePayload>): Promise<Synonym> {
        const response = await this.http.orchestrateRequest<{ data: Synonym }>({
            method: 'PATCH',
            url: `/docs/admin/search-terms/${id}`,
            body: payload,
            apiTarget: ApiTarget.VinService,
        });

        if (!response.success) {
            throw new Error('Failed to update synonym');
        }

        return response.data?.data;
    }
    async deleteSynonym(id: string): Promise<void> {
        const response = await this.http.orchestrateRequest<void>({
            method: 'DELETE',
            url: `/docs/admin/search-terms/${id}`,
            apiTarget: ApiTarget.VinService,
        });

        if (!response.success) {
            throw new Error('Failed to delete synonym');
        }
    }
}
